import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const UserSearch = lazy(() => import('./pages/UserSearch'));
const UserDetail = lazy(() => import('./pages/UserDetail'));

export const usersRoutes: RouteObject = {
  path: 'users',
  handle: { breadcrumb: 'Users' },
  children: [
    { index: true, element: <UserSearch />, handle: { breadcrumb: 'Search' } },
    { path: ':yumId', element: <UserDetail />, handle: { breadcrumb: 'Detail' } },
  ],
};
